module.exports = {
	"_from": "web3",
	"_id": "web3@1.0.0-beta.36",
	"_inBundle": false,
	"_integrity": "sha512-fZDunw1V0AQS27r5pUN3eOVP7u8YAvyo6vOapdgVRolAu5LgaweP7jncYyLINqIX9ZgWdS5A090bt+ymgaYHsw==",
	"_location": "/web3",
	"_phantomChildren": {},
	"_requested": {
		"type": "tag",
		"registry": true,
		"raw": "web3",
		"name": "web3",
		"escapedName": "web3",
		"rawSpec": "",
		"saveSpec": null,
		"fetchSpec": "latest"
	},
	"_requiredBy": [
		"#USER",
		"/"
	],
	"_resolved": "https://registry.npmjs.org/web3/-/web3-1.0.0-beta.36.tgz",
	"_shasum": "2954da9e431124c88396025510d840ba731c8373",
	"_spec": "web3",
	"_where": "/home/marko/EthereumAsyncProjects/AsyncCoinContract",
	"author": {
		"name": "ethereum.org"
	},
	"authors": [
		{
			"name": "Fabian Vogelsteller",
			"email": "fabian@ethereum.org",
			"homepage": "http://frozeman.de"
		},
		{
			"name": "Marek Kotewicz",
			"email": "marek@parity.io",
			"url": "https://github.com/debris"
		},
		{
			"name": "Marian Oancea",
			"url": "https://github.com/cubedro"
		},
		{
			"name": "Gav Wood",
			"email": "g@parity.io",
			"homepage": "http://gavwood.com"
		},
		{
			"name": "Jeffery Wilcke",
			"email": "jeffrey.wilcke@ethereum.org",
			"url": "https://github.com/obscuren"
		}
	],
	"bugs": {
		"url": "https://github.com/ethereum/web3.js/issues"
	},
	"bundleDependencies": false,
	"dependencies": {
		"web3-bzz": "1.0.0-beta.36",
		"web3-core": "1.0.0-beta.36",
		"web3-eth": "1.0.0-beta.36",
		"web3-eth-personal": "1.0.0-beta.36",
		"web3-net": "1.0.0-beta.36",
		"web3-shh": "1.0.0-beta.36",
		"web3-utils": "1.0.0-beta.36"
	},
	"deprecated": false,
	"description": "Ethereum JavaScript API",
	"keywords": [
		"Ethereum",
		"JavaScript",
		"API"
	],
	"license": "LGPL-3.0",
	"main": "src/index.js",
	"name": "web3",
	"namespace": "ethereum",
	"repository": {
		"type": "git",
		"url": "https://github.com/ethereum/web3.js/tree/master/packages/web3"
	},
	"version": "1.0.0-beta.36"
};


//////////////////
// WEBPACK FOOTER
// ./~/web3/package.json
// module id = 433
// module chunks = 0